function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Rewards = function Rewards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M8.171 3.741c-.235.22-.275.393-.273.517.002.155.075.338.218.527.038.05.179.175.5.36.298.173.678.357 1.106.546.327.145.668.287 1.006.424a12 12 0 0 0-1.103-1.89 1 1 0 0 1-.047-.076c-.522-.657-1.144-.577-1.407-.408m2.77-.187a1 1 0 0 0-.056-.093c-.99-1.375-2.666-1.521-3.671-.786l-.054.043c-.529.47-.77 1.01-.762 1.559.007.521.239.97.486 1.297.223.296.592.544.935.743.213.123.45.245.698.365H5c-1.519 0-2.75 1.135-2.75 2.534v9.217c0 1.4 1.231 2.534 2.75 2.534h14c1.519 0 2.75-1.134 2.75-2.534V9.216c0-1.4-1.231-2.534-2.75-2.534h-3.517c.249-.12.486-.242.698-.365.343-.198.712-.447.934-.742.248-.328.48-.776.488-1.298.008-.55-.234-1.09-.763-1.559l-.054-.043c-1.005-.735-2.68-.59-3.67.786a1 1 0 0 0-.057.093c-.43.61-.782 1.23-1.059 1.793a13 13 0 0 0-1.059-1.793m1.809 16.03H19c.69 0 1.25-.515 1.25-1.151v-3.917h-7.5zm-1.5-5.068v5.069H5c-.69 0-1.25-.516-1.25-1.152v-3.917zm1.5-1.383h7.5V9.217c0-.636-.56-1.152-1.25-1.152h-6.25zm-1.5-5.069v5.07h-7.5V9.215c0-.636.56-1.152 1.25-1.152zm3.125-3.838a1 1 0 0 0 .048-.077c.521-.657 1.144-.577 1.406-.408.235.22.275.393.274.517-.003.155-.076.338-.218.527h-.001c-.037.05-.179.175-.5.36-.297.173-.678.357-1.106.546-.327.145-.668.287-1.006.424.27-.575.636-1.241 1.103-1.89",
    clipRule: "evenodd"
  }));
};
export default Rewards;
Rewards.displayName = 'Rewards';